import routes from 'actions/routes';
import { generateCreateActionCreator, generateReadActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

export default {
    createField: generateCreateActionCreator(routes.API_CUSTOM_FIELDS_GROUPS, ACTION_NAMES.CUSTOM_FIELDS, () => {}, () => {}, 'field'),
    readMappingFields: generateReadActionCreator(routes.API_CUSTOM_FIELDS_MAPPINGS, ACTION_NAMES.CUSTOM_FIELDS_MAPPING),
    readAutomationFields: generateReadActionCreator(routes.API_AUTOMATION_FIELDS, ACTION_NAMES.AUTOMATION_FIELDS)
};
